import CanvasEditor from "./component/CanvasEditor";
import React, { useState, useRef, useEffect } from "react";
import axios from "axios";
import Carouselfp from "./component/Carosuelfp";
import PredefinedImages from "./component/PredifnedImages";
import Prompts from "./component/Prompts"; // Import the Prompts component
import { roomStyles, designStyles } from "./component/stylesData"; // Import the styles data
import "./FurnishingPage.css";
import { Link } from "react-router-dom";

function FurnishingPage() {
  const [uploadedImages, setUploadedImages] = useState([]);
  const [canvasImages, setCanvasImages] = useState([]);
  const canvasRef = useRef(null);
  const [hoveredImageIndex, setHoveredImageIndex] = useState(null);
  const [action, setAction] = useState(null);
  const [startMousePosition, setStartMousePosition] = useState({ x: 0, y: 0 });
  const [startImageProperties, setStartImageProperties] = useState({
    width: 0,
    height: 0,
    rotation: 0,
  });

  const {
    positivePrompt,
    negativePrompt,
    setPositivePrompt,
    setNegativePrompt,
    handleRoomSelect,
    handleDesignSelect,
    validatePrompts,
    addTechnicalParameters,
  } = Prompts({
    onPositivePromptChange: (positivePrompt) => {
      // Handle positive prompt change if needed
    },
    onNegativePromptChange: (negativePrompt) => {
      // Handle negative prompt change if needed
    },
    onRoomSelect: (positivePrompt, negativePrompt) => {
      // Handle room selection if needed
    },
    onDesignSelect: (positivePrompt, negativePrompt) => {
      // Handle design selection if needed
    },
  });

  // const [positivePrompt, setPositivePrompt] = useState("");
  // const [negativePrompt, setNegativePrompt] = useState("");
  const [imageUrl, setImageUrl] = useState(null);
  const [imageUploaded, setImageUploaded] = useState(false);
  const [uploadedImage, setUploadedImage] = useState(null);
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(false);


  const handleImageUpload = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = (event) => {
        const img = new window.Image();
        img.src = event.target.result;
        img.onload = () => {
          setUploadedImages((prev) => [...prev, img]);
        };
      };
      reader.readAsDataURL(file);
    }
  };

  const addImageToCanvas = (img) => {
    setCanvasImages((prev) => [
      ...prev,
      {
        image: img,
        x: 50,
        y: 50,
        width: img.width / 2,
        height: img.height / 2,
        rotation: 0,
      },
    ]);
  };

  // const removeImageFromCanvas = (index) => {
  //   setCanvasImages((prev) => prev.filter((_, i) => i !== index));
  //   setHoveredImageIndex(null);
  // };

  // const handleMouseDown = (e) => {
  //   const canvas = canvasRef.current;
  //   const rect = canvas.getBoundingClientRect();
  //   const mouseX = e.clientX - rect.left;
  //   const mouseY = e.clientY - rect.top;

  //   if (hoveredImageIndex !== null) {
  //     const img = canvasImages[hoveredImageIndex];

  //     if (
  //       mouseX >= img.x + img.width - 10 &&
  //       mouseX <= img.x + img.width &&
  //       mouseY >= img.y + img.height - 10 &&
  //       mouseY <= img.y + img.height
  //     ) {
  //       setAction("resize");
  //       setStartMousePosition({ x: mouseX, y: mouseY });
  //       setStartImageProperties({
  //         width: img.width,
  //         height: img.height,
  //         rotation: img.rotation,
  //       });
  //       return;
  //     }

  //     if (
  //       mouseX >= img.x + img.width - 10 &&
  //       mouseX <= img.x + img.width &&
  //       mouseY >= img.y &&
  //       mouseY <= img.y + 10
  //     ) {
  //       setAction("rotate");
  //       setStartMousePosition({ x: mouseX, y: mouseY });
  //       setStartImageProperties({
  //         width: img.width,
  //         height: img.height,
  //         rotation: img.rotation,
  //       });
  //       return;
  //     }

  //     if (
  //       mouseX >= img.x &&
  //       mouseX <= img.x + 10 &&
  //       mouseY >= img.y &&
  //       mouseY <= img.y + 10
  //     ) {
  //       removeImageFromCanvas(hoveredImageIndex);
  //       return;
  //     }

  //     setAction("drag");
  //     setStartMousePosition({ x: mouseX, y: mouseY });
  //   }
  // };

  // const handleMouseMove = (e) => {
  //   const canvas = canvasRef.current;
  //   const rect = canvas.getBoundingClientRect();
  //   const mouseX = e.clientX - rect.left;
  //   const mouseY = e.clientY - rect.top;

  //   if (hoveredImageIndex !== null && action) {
  //     const img = canvasImages[hoveredImageIndex];

  //     if (action === "drag") {
  //       const deltaX = mouseX - startMousePosition.x;
  //       const deltaY = mouseY - startMousePosition.y;
  //       setCanvasImages((prev) =>
  //         prev.map((img, i) =>
  //           i === hoveredImageIndex
  //             ? { ...img, x: img.x + deltaX, y: img.y + deltaY }
  //             : img
  //         )
  //       );
  //       setStartMousePosition({ x: mouseX, y: mouseY });
  //     } else if (action === "resize") {
  //       const deltaX = mouseX - startMousePosition.x;
  //       const deltaY = mouseY - startMousePosition.y;
  //       const newWidth = startImageProperties.width + deltaX;
  //       const newHeight = startImageProperties.height + deltaY;
  //       setCanvasImages((prev) =>
  //         prev.map((img, i) =>
  //           i === hoveredImageIndex
  //             ? { ...img, width: newWidth, height: newHeight }
  //             : img
  //         )
  //       );
  //     } else if (action === "rotate") {
  //       const centerX = img.x + img.width / 2;
  //       const centerY = img.y + img.height / 2;
  //       const deltaX = mouseX - centerX;
  //       const deltaY = mouseY - centerY;
  //       const angle = (Math.atan2(deltaY, deltaX) * 180) / Math.PI;
  //       setCanvasImages((prev) =>
  //         prev.map((img, i) =>
  //           i === hoveredImageIndex ? { ...img, rotation: angle } : img
  //         )
  //       );
  //     }
  //   }

  //   for (let i = canvasImages.length - 1; i >= 0; i--) {
  //     const img = canvasImages[i];
  //     if (
  //       mouseX >= img.x &&
  //       mouseX <= img.x + img.width &&
  //       mouseY >= img.y &&
  //       mouseY <= img.y + img.height
  //     ) {
  //       setHoveredImageIndex(i);
  //       break;
  //     } else {
  //       setHoveredImageIndex(null);
  //     }
  //   }
  // };

  // const handleMouseUp = () => {
  //   setAction(null);
  // };

  // const drawCanvas = () => {
  //   const canvas = canvasRef.current;
  //   if (!canvas) return; // Check if canvas is null
  //   const ctx = canvas.getContext("2d");
  //   ctx.clearRect(0, 0, canvas.width, canvas.height);

  //   canvasImages.forEach((img, index) => {
  //     ctx.save();
  //     ctx.translate(img.x + img.width / 2, img.y + img.height / 2);
  //     ctx.rotate((img.rotation * Math.PI) / 180);
  //     ctx.drawImage(
  //       img.image,
  //       -img.width / 2,
  //       -img.height / 2,
  //       img.width,
  //       img.height
  //     );
  //     ctx.restore();

  //     if (index === hoveredImageIndex) {
  //       // Draw resize, rotate, and delete icons
  //       ctx.fillStyle = "blue";
  //       ctx.fillRect(img.x + img.width - 10, img.y + img.height - 10, 10, 10);

  //       ctx.fillStyle = "green";
  //       ctx.beginPath();
  //       ctx.arc(img.x + img.width - 10, img.y + 10, 10, 0, 2 * Math.PI);
  //       ctx.fill();

  //       ctx.fillStyle = "red";
  //       ctx.beginPath();
  //       ctx.arc(img.x + 10, img.y + 10, 10, 0, 2 * Math.PI);
  //       ctx.fill();
  //     }
  //   });
  // };

  // useEffect(() => {
  //   drawCanvas(); // Call drawCanvas only after the component has rendered
  // }, [canvasImages, hoveredImageIndex]);

  const handleDownloadImage = () => {
    const canvas = canvasRef.current;
    const imageData = canvas.toDataURL("image/png");

    if (!canvasImages.length) {
      alert("No images to download.");
      return;
  }

  // Calculate bounding box of all images
  let minX = Infinity, minY = Infinity, maxX = 0, maxY = 0;

  canvasImages.forEach(img => {
      minX = Math.min(minX, img.x);
      minY = Math.min(minY, img.y);
      maxX = Math.max(maxX, img.x + img.width);
      maxY = Math.max(maxY, img.y + img.height);
  });

  const cropWidth = maxX - minX;
  const cropHeight = maxY - minY;

  // Create a new temporary canvas with the exact cropped size
  const tempCanvas = document.createElement("canvas");
  tempCanvas.width = cropWidth;
  tempCanvas.height = cropHeight;
  const tempCtx = tempCanvas.getContext("2d");

  // Draw images onto the cropped canvas
  canvasImages.forEach(img => {
      tempCtx.save();
      tempCtx.translate(img.x - minX + img.width / 2, img.y - minY + img.height / 2);
      tempCtx.rotate((img.rotation * Math.PI) / 180);
      tempCtx.drawImage(img.image, -img.width / 2, -img.height / 2, img.width, img.height);
      tempCtx.restore();
  });

  // Convert cropped canvas to image
  const croppedImageData = tempCanvas.toDataURL("image/png");

  // Download the cropped image
  const link = document.createElement("a");
  link.download = "cropped-canvas.png";
  link.href = croppedImageData;
  link.click();
  };




const handleDownloadAndGenerate = async () => {
  const canvas = canvasRef.current;
  const ctx = canvas.getContext("2d");

  if (!canvasImages.length) {
      alert("No images to download.");
      return;
  }

  // Calculate bounding box of all images
  let minX = Infinity, minY = Infinity, maxX = 0, maxY = 0;

  canvasImages.forEach(img => {
      minX = Math.min(minX, img.x);
      minY = Math.min(minY, img.y);
      maxX = Math.max(maxX, img.x + img.width);
      maxY = Math.max(maxY, img.y + img.height);
  });

  const cropWidth = maxX - minX;
  const cropHeight = maxY - minY;

  // Create a new temporary canvas with the exact cropped size
  const tempCanvas = document.createElement("canvas");
  tempCanvas.width = cropWidth;
  tempCanvas.height = cropHeight;
  const tempCtx = tempCanvas.getContext("2d");

  // Draw images onto the cropped canvas
  canvasImages.forEach(img => {
      tempCtx.save();
      tempCtx.translate(img.x - minX + img.width / 2, img.y - minY + img.height / 2);
      tempCtx.rotate((img.rotation * Math.PI) / 180);
      tempCtx.drawImage(img.image, -img.width / 2, -img.height / 2, img.width, img.height);
      tempCtx.restore();
  });

  // Convert cropped canvas to image
  const croppedImageData = tempCanvas.toDataURL("image/png");

  // Download the cropped image
  const link = document.createElement("a");
  link.download = "cropped-canvas.png";
  link.href = croppedImageData;
  link.click();

  // Send cropped image to API
  const blob = await fetch(croppedImageData).then(res => res.blob());
  const formData = new FormData();
  formData.append("positive_prompt", addTechnicalParameters(positivePrompt));
  formData.append("negative_prompt", negativePrompt);
  formData.append("image", blob, "cropped-canvas.png");

  try {
      const response = await axios.post("https://eighty-guests-lose.loca.lt/controlnet", formData);
      if (response.data.image_url) {
          setImageUrl(response.data.image_url);
      } else {
          setError(response.data.error);
      }
  } catch (error) {
      console.error("Error:", error);
      setError("An error occurred. Please try again.");
  }
};


  // const extractCorePrompt = (prompt) => {
  //   const cleanPrompt = prompt.replace(
  //     /(best quality:1\.4|masterpiece:1\.4|photorealistic:1\.4|ultra high res, raw photo:1\.4|hdr, hyperdetailed:1\.2|8K:1\.2|real|realistic|super detailed|4k|8k|interior),*/g,
  //     ""
  //   ).trim();
  //   return cleanPrompt.replace(/[\(\)]/g, "").trim();
  // };

  // const addTechnicalParameters = (prompt) => {
  //   return `(best quality:1.4),(masterpiece:1.4),(photorealistic:1.4),(ultra high res, raw photo:1.4),(hdr, hyperdetailed:1.2),(8K:1.2),real,(realistic),super detailed,(4k),8k,interior, ${prompt}`;
  // };

  // const handleRoomSelect = (selectedItem) => {
  //   setPositivePrompt(extractCorePrompt(selectedItem.positivePrompt));
  //   setNegativePrompt(extractCorePrompt(selectedItem.negativePrompt));
  // };

  // const handleDesignSelect = (selectedItem) => {
  //   const designPositivePrompt = extractCorePrompt(selectedItem.positivePrompt);
  //   const designNegativePrompt = extractCorePrompt(selectedItem.negativePrompt);

  //   setPositivePrompt((prev) => {
  //     const currentPrompt = extractCorePrompt(prev);
  //     return currentPrompt ? `${currentPrompt}, ${designPositivePrompt}` : designPositivePrompt;
  //   });

  //   setNegativePrompt((prev) => {
  //     const currentPrompt = extractCorePrompt(prev);
  //     return currentPrompt ? `${currentPrompt}, ${designNegativePrompt}` : designNegativePrompt;
  //   });
  // };

  // const validatePrompts = () => {
  //   if (!positivePrompt.trim()) {
  //     setError("Positive prompt cannot be empty.");
  //     return false;
  //   }
  //   return true;
  // };

  const handleControlNet = async () => {
    if (!validatePrompts()) return;
  
    setError(null);
    setIsLoading(true);
  
    const canvas = canvasRef.current;
    const imageData = canvas.toDataURL("image/png"); // Convert canvas to image
  
    const formData = new FormData();
    formData.append("positive_prompt", addTechnicalParameters(positivePrompt));
    formData.append("negative_prompt", negativePrompt);
    formData.append("steps", 20);
    formData.append("cfg_scale", 7.5);
    formData.append("width", 400);
    formData.append("height", 400);
    formData.append("sampler_index", "Euler a");
    formData.append("weight", 1.0);
    formData.append("resize_mode", "Scale to Fit");
    formData.append("lowvram", false);
  
    // Convert data URL to Blob and append to FormData
    const blob = await fetch(imageData).then((res) => res.blob());
    formData.append("image", blob, "canvas-image.png");
  
    try {
      const response = await axios.post(
        "https://eighty-guests-lose.loca.lt/controlnet",
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
  
      if (response.data.image_url) {
        setImageUrl(response.data.image_url); // Set the generated image URL
      } else if (response.data.error) {
        setError(response.data.error);
      }
      console.log("Generated Image URL:", response.data.image_url);
    } catch (error) {
      console.error("Error:", error);
      setError("An error occurred. Please try again.");
    } finally {
      setIsLoading(false);
    }
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = (event) => {
        const img = new window.Image();
        img.src = event.target.result;
        img.onload = () => {
          setUploadedImage(img); // Save reference to the background image
          addImageToCanvas(img); // Add the uploaded image to the canvas
        };
      };
      reader.readAsDataURL(file);
    }
  };

  const removeImage = () => {
    setUploadedImage(null);
    setImageUploaded(false); // Reset the state
  };

    

  return (
    <div>
    <nav className="navbarfp">
      <h1>Refurbish Homes</h1>
      <Link to="/tools" className="nav-home-buttonfp">Home</Link>
      <Link to="/main" className="nav-home-buttonfp">Image Generation</Link>
    </nav>
      
    <div className="app-containerfp">
      <div className="left-columnfp">
        <h2>REFURBISH YOUR HOMES</h2>
        <form onSubmit={handleControlNet} encType="multipart/form-data">
          <div className="file-input-containerfp">
          {/* Hidden file input */}
            <input
              type="file"
              id="controlnet-upload"
              accept="image/*"
              onChange={handleImageUpload}
              className="hidden"  // Hide the default input
            />
        
            {/* Custom styled label that triggers the file input */}
            <label
              htmlFor="controlnet-upload"
              className="custom-upload-button"
            >
              <div className="button-content">
                <svg className="upload-icon" viewBox="0 0 24 24">
                  <path d="M19 13v5a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2v-5M12 5v12m-5-5l5-5 5 5"/>
                </svg>
                <span>Choose Images</span>
              </div>
            </label>

            {/* Uploaded images preview */}
            <div className="uploaded-images-grid">
              {uploadedImages.map((img, index) => (
                <div
                  key={index}
                  className="uploaded-imagefp"
                  onClick={() => addImageToCanvas(img)}
                >
                  <img src={img.src} alt={`uploaded-${index}`} />
                </div>
              ))}
            </div>
          </div>

          {/* {imageUploaded && (
            <button
              type="button"
              onClick={removeImage}
              className="mt-2 px-4 py-2 text-white bg-red-500 rounded-md"
            >
              Remove Image
            </button>
          )} */}
          {/* this prompt boxes for future  */}
          {/* <input
            type="text"
            name="positive_prompt"
            placeholder="Enter positive prompt"
            value={positivePrompt}
            onChange={(e) => setPositivePrompt(e.target.value)}
            required
          />
          <input
            type="text"
            name="negative_prompt"
            placeholder="Enter Negative Prompt"
            value={negativePrompt}
            onChange={(e) => setNegativePrompt(e.target.value)}
          /> */}
          {/* <button className="controlnetbuttonfp" type="submit" disabled={isLoading}>
            {isLoading ? "Processing..." : "Process with ControlNet"}
          </button> */}
        </form>

        {/* Predefined Images Section */}

        <PredefinedImages addImageToCanvas={addImageToCanvas} />
        {/* carousel somponents for future */}
        {/* <Carouselfp data={roomStyles} title="Room Styles" onSelect={handleRoomSelect} />
        <Carouselfp data={designStyles} title="Design Styles" onSelect={handleDesignSelect} /> */}
      </div>

      <div className="canvas-section">
        <CanvasEditor canvasRef={canvasRef} canvasImages={canvasImages} setCanvasImages={setCanvasImages} />


        <button className="download-button" onClick={handleDownloadImage}>
          Download Image
        </button>
        {/* <button
          className="download-generate-buttonfp"
          onClick={handleDownloadAndGenerate}
          disabled={isLoading}
        >
          {isLoading ? "Processing..." : "Generate Image"}
        </button> */}
        {/* Display the generated image below the canvas */}
        {imageUrl && (
            <div className="generated-image-sectionfp">
                <h3>Generated Image</h3>
                 <img src={imageUrl} alt="Generated Image" className="generated-imagefp" />
                <button
                    className="clear-image-buttonfp"
                    onClick={() => setImageUrl(null)} // Clear the generated image
                >
                Clear Image
                </button>
            </div>
        )}
      </div>
    </div>
  </div> 
  );
}

export default FurnishingPage;


